const FormControl=(props)=>{
    const { className = '' } = props
    return(
        <div className={"mb-3 "+className}>
                {props.children}
        </div>
    )
}
export default FormControl